import { Checkbox as NextUICheckbox } from '@nextui-org/react'
import { Controller, type FieldPath, type FieldValues } from 'react-hook-form'

import type { ControlledCheckboxProps } from './type'

export function Checkbox<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  fieldProps,
  label,
  name,
  rules,
}: Readonly<ControlledCheckboxProps<TFieldValues, TName>>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onBlur, onChange, value },
        fieldState: { error, invalid },
      }) => (
        <>
          <NextUICheckbox
            classNames={{
              label: 'uppercase',
            }}
            isInvalid={invalid}
            isRequired={rules?.required as boolean}
            isSelected={value}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            {...fieldProps}
          >
            {label}
          </NextUICheckbox>
          {error?.message && (
            <span className="mt-1 block text-xs text-red-500">
              {error.message}
            </span>
          )}
        </>
      )}
      rules={rules}
    />
  )
}

export default Checkbox

{
  /* <Controller
name={props.name}
control={props.control}
rules={props.rules}
render={({
  field: { onChange, onBlur, value },
  fieldState: { error, invalid },
}) => (
  <>
    <Checkbox
      className={props.className}
      isRequired={props.rules?.required ? true : false}
      onBlur={onBlur}
      onChange={onChange}
      isSelected={value}
      isInvalid={invalid}
      readOnly={props.readOnly}
      disabled={props.disabled}
    >
      {props.label}
    </Checkbox>
    {error && error?.message && (
      <span className="mt-1 block text-xs text-red-500">
        {error?.message}
      </span>
    )}
  </>
)}
/> */
}
